// extracted by mini-css-extract-plugin
export default {"panacoSearchContainer":"styles_panacoSearchContainer__9Efmc"};